import { Meta } from '@/layouts/Meta';
import { Main } from '@/templates/Main';

const StudentBeans = () => {
  return (
    <Main
      meta={
        <Meta
          title={'Student Discount'}
          description={'My Muscle Chef Discount'}
          canonical={`${process.env.NEXT_PUBLIC_SITE_URL}/student-discount`}
          noIndexing={true}
        />
      }
    >
      <div className="h-[720px] w-full">
        <iframe
          src="https://connect.studentbeans.com/v4/my-muscle-chef/au"
          data-iframe="https://connect.studentbeans.com/v4/my-muscle-chef/au"
          data-load="connect"
          id="stb_root"
          title="Student Beans"
          width="100%"
          height="100%"
        />
      </div>
    </Main>
  );
};

export default StudentBeans;
